define((require) => {
    "use strict";

    var Marionette      = require("marionette"),
        CommentItemView = require("ui/comments/CommentItemView");

    /**
     * The collection view of comments.
     *
     * @author Bruce Mackenzie Nielsen
     * @class CommentCollectionView
     * @constructor
     */
    return Marionette.CompositeView.extend({
        template: function() { return ""; },
        className: "comment-collection-view",
        itemView: CommentItemView,
        initialize: function() {
            this.itemViewOptions = {
                viewModel: this.options.viewModel
            };
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/comments/CommentCollectionView.js